import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import HamburgerMenu from "./Hamburger";
import bigLogo from "../../assets/logo_header.png";
import {fontType} from "../../constants/font";
import {courses} from "../../data/courses";
import CourseSearchLink from "./search/CourseSearchLink";
import axios from "axios";

const Header = () => {
  const [fetchedCoursesData, setFetchedCoursesData] = useState([]);
  const [isScrolledBelowThreshold, setIsScrolledBelowThreshold] = useState(false);

  const handleScroll = () => {
    const threshold = 54; // Set your desired threshold value

    const isBelowThreshold = window.scrollY > threshold;
    setIsScrolledBelowThreshold(isBelowThreshold);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

    useEffect(() => {
        const fetchCourseData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}trainings?filter=with_valid_terms`);
                const data = response.data?.data;

                if (data) {
                    const coursesData = courses.map((course) => {
                            const courseData = data.find(
                                (item) => item.code === course.code
                            );
                            return {
                                ...course,
                                id: courseData.id,
                                name: courseData.name,
                            }
                        }
                    )
                    setFetchedCoursesData(coursesData);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchCourseData();
    }, []);

  const location = useLocation();
  const isHome = location.pathname === '/';

  const isActive = (pathname) => {
    return location.pathname === pathname;
  };

  const scrollToSection = (sectionId) => {
    setIsHovered(false);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchContainerRef = useRef(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleSearchToggle = () => {
    setIsHovered(false);
    setIsSearchOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!isSearchOpen) {
      return;
    }

    const handleOutsideClick = (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest(".MuiAutocomplete-popper")
      ) {
        return;
      }

      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isSearchOpen]);

  useEffect(() => {
    setIsSearchOpen(false);
  }, [location.pathname]);

const scrollToTop = (event) => {
    if (isHome) {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
};

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          paddingTop: "29px",
          paddingBottom: "27px",
          backgroundColor: "white",
          zIndex: 50,
        }}
      >
        <Box
          sx={{
            position: "relative",
            maxWidth: "1440px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
                display: "block",
                height: "66px"
            }}
          >
          </Box>
        </Box>
      </Box>
      <Box
        id="header"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          paddingTop: "29px",
          paddingBottom: "27px",
          backgroundColor: "white",
          position: "fixed",
          top: 0,
          borderBottom: isScrolledBelowThreshold ? "1px solid" : "unset",
          zIndex: 50,
        }}
      >
        <Box
          sx={{
            position: "relative",
            maxWidth: "1440px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              marginLeft: { lg: "6.6vw", md: "1vw", xs: "0px" },
              marginRight: { md: "20px", xs: "0px" },
              display: { md: "block", xs: "none" },
            }}
          >
            <Link style={{ textDecoration: "none" }} to={"/"} onClick={scrollToTop}>
              <img
                src={bigLogo}
                style={{ maxWidth: "357px", maxHeight: "66px" }}
                alt="academy_logo"
              />
            </Link>
          </Box>
          <Box
            sx={{
              display: { md: "none", xs: "flex" },
              paddingLeft: "9vw",
              paddingRight: "9vw",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Box sx={{ position: "absolute", top: "-10px", left: "20px" }}>
              <HamburgerMenu courses={fetchedCoursesData} />
            </Box>
            <Box
              sx={{
                marginLeft: { md: "6.6vw", xs: "0px" },
                marginRight: { md: "20px", xs: "0px" },
              }}
            >
              <Link style={{ textDecoration: "none" }} to={"/"} onClick={scrollToTop}>
                {windowWidth > 500 ? (
                  <img
                    src={require("../../assets/logo_header.png")}
                    style={{ width: "357px", height: "66px" }}
                    alt="academy_logo"
                  />
                ) : (
                  <img
                    src={bigLogo}
                    style={{ width: "250px" }}
                    alt="academy_logo"
                  />
                )}
              </Link>
            </Box>
          </Box>
            <Box
              sx={{
                display: { md: "flex", xs: "none" },
                alignItems: "center",
                marginRight: { lg: "1.78vw", md: "1vw", xs: "0px" },
                width: { md: "100%" },
                justifyContent: "flex-end",
                gap: "16px",
              }}
            >
              <Box
                ref={searchContainerRef}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: "32px",
                }}
              >
                <Box
                  onClick={handleSearchToggle}
                  sx={{
                    width: "32px",
                    height: "32px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#1d1a56",
                    flexShrink: 0,
                    marginTop: "8px"
                  }}
                  title="Nájdi školenie"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                    style={{
                      width: "22px",
                      height: "22px",
                      fill: isSearchOpen ? "#f6961d" : "#1d1a56",
                    stroke: isSearchOpen ? "#f6961d" : "#1d1a56",
                    strokeWidth: "30"
                    }}
                  >
                    <path d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416C351.5 416 416 351.5 416 272C416 192.5 351.5 128 272 128C192.5 128 128 192.5 128 272C128 351.5 192.5 416 272 416z" />
                  </svg>
                </Box>
                <Box
                  sx={{
                    width: isSearchOpen ? { lg: "540px", md: "390px" } : "0px",
                    // overflow: "hidden",
                    marginLeft: isSearchOpen ? "12px" : "0px",
                    marginTop: "8px",
                    transition: isSearchOpen
                      ? "width 260ms ease, margin-left 260ms ease"
                      : "none",
                    pointerEvents: isSearchOpen ? "auto" : "none",
                  }}
                >
                  <Box
                    sx={{
                      width: { lg: "540px", md: "390px" },
                      transform: isSearchOpen ? "scaleX(1)" : "scaleX(0)",
                      transformOrigin: "left center",
                      opacity: isSearchOpen ? 1 : 0,
                      transition: isSearchOpen
                        ? "transform 260ms ease, opacity 180ms ease"
                        : "none",
                    }}
                  >
                    <CourseSearchLink courses={fetchedCoursesData} focusOnOpen={isSearchOpen} />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                    display: "flex",
                    maxWidth: "669px",
                    width: isSearchOpen ? "0px" : {md: "100%"},
                    justifyContent: "space-between",
                    gap: {md: "0px", xs: "15px"},
                    overflow: isSearchOpen ? "hidden" : "visible",
                    opacity: isSearchOpen ? 0 : 1,
                    transform: isSearchOpen ? "scaleX(0)" : "scaleX(1)",
                    transformOrigin: "right center",
                    transition: "width 260ms ease, opacity 200ms ease, transform 200ms ease",
                    pointerEvents: isSearchOpen ? "none" : "auto",
                }}
              >
                <Link style={{textDecoration: "none"}} to={"/"}>
                    <Typography
                        sx={{
                            fontFamily: fontType.medium,
                            color: isActive("/") ? "#f6961d" : "#1d1a56",
                            textTransform: "initial",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            fontSize: {sm: 22, xs: 18},
                            marginTop: "8px",
                        }}
                    >
                        Academy
                    </Typography>
                </Link>
                <Box sx={{position: "relative"}}>
                    <Link
                        style={{textDecoration: "none"}}
                        to={"/skolenia"}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Typography
                            sx={{
                                fontFamily: fontType.medium,
                                color: isActive("/skolenia") ? "#f6961d" : "#1d1a56",
                                textTransform: "initial",
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                                fontSize: {sm: 22, xs: 18},
                                marginTop: "8px",
                            }}
                        >
                            Vybrať školenie
                        </Typography>
                    </Link>
                    {isHovered && (
                        <Box
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            sx={{
                                paddingTop: "15px",
                                position: "absolute",
                                zIndex: 150,
                                right: -110,
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: "white",
                                    minWidth: "300px",

                                    display: {md: "flex", xs: "none"},

                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    borderRadius: "25px",
                                    border: "2px solid",
                                    borderColor: "#1b144a",
                                    paddingTop: "20px",
                                    paddingBottom: "20px",
                                }}
                            >
                                {isActive("/skolenia") ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            width: "100%",
                                            justifyContent: "start",
                                        }}
                                        onClick={() => scrollToSection("course-list")}
                                    >
                                        <Typography
                                            sx={{
                                                paddingLeft: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                height: "45px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                                width: "100%",
                                            }}
                                        >
                                            Školenia
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Link
                                        style={{
                                            textDecoration: "none",
                                            width: "100%",
                                            display: "flex",
                                        }}
                                        to={"/skolenia#course-list"}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                display: "flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                height: "45px",
                                                width: "100%",
                                                justifyContent: "start",
                                                paddingLeft: "20px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            Školenia
                                        </Typography>
                                    </Link>
                                )}
                                {isActive("/skolenia") ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      width: "100%",
                                      justifyContent: "start",
                                    }}
                                    onClick={() => scrollToSection("kompas")}
                                  >
                                    <Typography
                                      sx={{
                                        paddingLeft: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        fontSize: { sm: 20, xs: 18 },
                                        fontFamily: fontType.medium,
                                        color: "#1d1a56",
                                        textTransform: "initial",
                                        height: "45px",
                                        "&:hover": {
                                          backgroundColor: "#1b144a",
                                          color: "white",
                                        },
                                        width: "100%",
                                      }}
                                    >
                                      Zručnosti pre trh práce <span style={{ color: "orange", marginLeft:"5px" }}>pre NEZAMESTNANÝCH</span>
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Link
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                      display: "flex",
                                    }}
                                    to={"/skolenia#kompas"}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: fontType.medium,
                                        color: "#1d1a56",
                                        textTransform: "initial",
                                        display: "flex",
                                        // borderTopLeftRadius: "21px",
                                        // borderTopRightRadius: "21px",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        fontSize: { sm: 20, xs: 18 },
                                        height: "45px",
                                        width: "100%",
                                        justifyContent: "start",
                                        paddingLeft: "20px",
                                        "&:hover": {
                                          backgroundColor: "#1b144a",
                                          color: "white",
                                        },
                                      }}
                                    >
                                    Zručnosti pre trh práce <span style={{ color: "orange", marginLeft:"5px" }}>pre NEZAMESTNANÝCH</span>
                                    </Typography>
                                  </Link>
                                )}
                                {isActive("/skolenia") ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",

                                      cursor: "pointer",

                                      // borderTopLeftRadius: "21px",
                                      // borderTopRightRadius: "21px",
                                      width: "100%",
                                      justifyContent: "start",
                                    }}
                                    onClick={() => scrollToSection("nestracaj-pracu")}
                                  >
                                    <Typography
                                      sx={{
                                        paddingLeft: "20px",
                                        paddingRight: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        fontSize: { sm: 20, xs: 18 },
                                        fontFamily: fontType.medium,
                                        color: "#1d1a56",
                                        textTransform: "initial",
                                        whiteSpace: "nowrap",
                                        height: "45px",
                                        "&:hover": {
                                          backgroundColor: "#1b144a",
                                          color: "white",
                                        },
                                        // borderTopLeftRadius: "21px",
                                        // borderTopRightRadius: "21px",
                                        width: "100%",
                                      }}
                                    >
                                    Príspevok na vzdelávanie <span style={{ color: "orange", marginLeft:"5px" }}>pre ZAMESTNANÝCH</span>

                                    </Typography>
                                  </Box>
                                ) : (
                                  <Link
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                      display: "flex",
                                    }}
                                    to={"/skolenia#nestracaj-pracu"}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: fontType.medium,
                                        color: "#1d1a56",
                                        textTransform: "initial",
                                        whiteSpace: "nowrap",
                                        display: "flex",
                                        // borderTopLeftRadius: "21px",
                                        // borderTopRightRadius: "21px",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        fontSize: { sm: 20, xs: 18 },
                                        height: "45px",
                                        width: "100%",
                                        justifyContent: "start",
                                        paddingLeft: "20px",
                                        paddingRight: "20px",
                                        "&:hover": {
                                          backgroundColor: "#1b144a",
                                          color: "white",
                                        },
                                      }}
                                    >
                                    Príspevok na vzdelávanie <span style={{ color: "orange", marginLeft:"5px" }}>pre ZAMESTNANÝCH</span>
                                    </Typography>
                                  </Link>
                                )}
                                {isActive("/skolenia") ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",

                                            cursor: "pointer",

                                            // borderTopLeftRadius: "21px",
                                            // borderTopRightRadius: "21px",
                                            width: "100%",
                                            justifyContent: "start",
                                        }}
                                        onClick={() => scrollToSection("financovanie")}
                                    >
                                        <Typography
                                            sx={{
                                                paddingLeft: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                height: "45px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                                // borderTopLeftRadius: "21px",
                                                // borderTopRightRadius: "21px",
                                                width: "100%",
                                            }}
                                        >
                                            Financovanie školení
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Link
                                        style={{
                                            textDecoration: "none",
                                            width: "100%",
                                            display: "flex",
                                        }}
                                        to={"/skolenia#financovanie"}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                display: "flex",
                                                // borderTopLeftRadius: "21px",
                                                // borderTopRightRadius: "21px",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                height: "45px",
                                                width: "100%",
                                                justifyContent: "start",
                                                paddingLeft: "20px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            Financovanie školení
                                        </Typography>
                                    </Link>
                                )}
                                {isActive("/skolenia") ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",

                                            cursor: "pointer",

                                            // borderTopLeftRadius: "21px",
                                            // borderTopRightRadius: "21px",
                                            width: "100%",
                                            justifyContent: "start",
                                        }}
                                        onClick={() => scrollToSection("na-splatky")}
                                    >
                                        <Typography
                                            sx={{
                                                paddingLeft: "20px",
                                                display: "flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                height: "45px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                                // borderTopLeftRadius: "21px",
                                                // borderTopRightRadius: "21px",
                                                width: "100%",
                                            }}
                                        >
                                            N<span style={{color: "#f6961d"}}>AA S</span>
                                            PLÁTKY{" "}
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Link
                                        style={{
                                            textDecoration: "none",
                                            width: "100%",
                                            display: "flex",
                                        }}
                                        to={"/skolenia#na-splatky"}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: fontType.medium,
                                                color: "#1d1a56",
                                                textTransform: "initial",
                                                display: "flex",
                                                // borderTopLeftRadius: "21px",
                                                // borderTopRightRadius: "21px",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                fontSize: {sm: 20, xs: 18},
                                                height: "45px",
                                                width: "100%",
                                                justifyContent: "start",
                                                paddingLeft: "20px",
                                                "&:hover": {
                                                    backgroundColor: "#1b144a",
                                                    color: "white",
                                                },
                                            }}
                                        >
                                            N<span style={{color: "#f6961d"}}>AA S</span>
                                            PLÁTKY{" "}
                                        </Typography>
                                    </Link>
                                )}
                            </Box>
                        </Box>
                    )}
                </Box>
                <Link style={{textDecoration: "none"}} to={"/success_stories"}>
                    <Typography
                        sx={{
                            fontFamily: fontType.medium,
                            color: isActive("/success_stories") ? "#f6961d" : "#1d1a56",
                            textTransform: "initial",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            fontSize: {sm: 22, xs: 18},
                            marginTop: "8px",
                        }}
                    >
                        Success Stories
                    </Typography>
                </Link>
                <Link style={{textDecoration: "none"}} to={"/faq"}>
                    <Typography
                        sx={{
                            fontFamily: fontType.medium,
                            color: isActive("/faq") ? "#f6961d" : "#1d1a56",
                            textTransform: "initial",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            fontSize: {sm: 22, xs: 18},
                            marginTop: "8px",
                        }}
                    >
                        FAQ
                    </Typography>
                </Link>
                <Link style={{textDecoration: "none"}} to={"/kontakt"}>
                    <Typography
                        sx={{
                            fontFamily: fontType.medium,
                            color: isActive("/kontakt") ? "#f6961d" : "#1d1a56",
                            textTransform: "initial",
                            display: "flex",
                            alignItems: "center",
                            textDecoration: "none",
                            fontSize: {sm: 22, xs: 18},
                            marginTop: "8px",
                        }}
                    >
                        Kontakt
                    </Typography>
                </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
